export const PERIOD_HEIGHT = 24;
export const PERIOD_GAP = 4;
